import type { ReactNode, RefObject } from 'react';
import { useState } from 'react';
import type { PlanWithAgePremiums } from '@/components/widgets/PlansSection';
import type { AllRatesModalCompareProps } from '@/components/elements/MonthlyPremium/types';
import { AllRatesModal } from '@/components/elements/ViewAllRatesModal';
import { PremiumBlock } from './PremiumBlock';
import { RightSectionWrapper } from './RightSectionWrapper';
import Button from '../Button/Button';

export function AgeRangePremium({
    rowRef,
    rightSection,
    rightRef,
    isRightWrapped,
    plan,
    premiumAge18,
    premiumAge65,
    hideViewAllRatesButton = false,
    allRatesModalCompare,
}: {
    rowRef: RefObject<HTMLDivElement | null>;
    rightSection?: ReactNode;
    rightRef: RefObject<HTMLDivElement | null>;
    isRightWrapped: boolean;
    plan: PlanWithAgePremiums;
    premiumAge18?: string;
    premiumAge65?: string;
    hideViewAllRatesButton?: boolean;
    allRatesModalCompare?: AllRatesModalCompareProps;
}) {
    const [isAllRatesOpen, setIsAllRatesOpen] = useState(false);

    return (
        <div className="w-full rounded-2xl">
            {!hideViewAllRatesButton && (
                <AllRatesModal
                    isOpen={isAllRatesOpen}
                    onClose={() => setIsAllRatesOpen(false)}
                    plan={plan}
                    lockBodyScroll={false}
                    zClassName="z-[200]"
                    onToggleCompare={allRatesModalCompare?.onToggleCompare}
                    isCompared={allRatesModalCompare?.isCompared}
                    comparePosition={allRatesModalCompare?.comparePosition}
                    compareTotal={allRatesModalCompare?.compareTotal}
                />
            )}
            <div
                ref={rowRef}
                className="flex flex-col items-stretch justify-start gap-3 lg:flex-row lg:flex-wrap lg:items-start lg:justify-start lg:gap-4"
            >
                <div className="flex w-full min-w-0 flex-1 flex-row items-center justify-start gap-3 sm:w-auto">
                    <div className="flex w-full flex-wrap items-center justify-start gap-3">
                        <PremiumBlock label="Age 18" premium={premiumAge18} className="h-[56px] max-w-[100px] w-full md:h-[56px] lg:h-[38px] md:max-w-[100px] lg:max-w-[180px]" />
                        {hideViewAllRatesButton ? (
                            <span className="shrink-0 text-sm text-gray-900" aria-hidden>
                                to
                            </span>
                        ) : (
                            <Button type="button" variant="link" onClick={() => setIsAllRatesOpen(true)}>View All <br/> Rates</Button>
                        )}
                        <PremiumBlock label="Age 65" premium={premiumAge65} className="h-[56px] max-w-[100px] w-full md:h-[56px] lg:h-[38px] md:max-w-[100px] lg:max-w-[180px]" />
                    </div>
                    {/* Mobile + Tablet only; hidden on desktop */}
                    <div className="ml-auto flex lg:hidden shrink-0 flex-col items-end text-base font-medium text-gray-800 leading-tight text-right">
                        <span className="whitespace-nowrap">Monthly</span>
                        <span className="whitespace-nowrap">Premium</span>
                    </div>
                </div>

                <RightSectionWrapper
                    rightSection={rightSection}
                    rightRef={rightRef}
                    isRightWrapped={isRightWrapped}
                    variant="ageRange"
                />
            </div>
        </div>
    );
}

